import { useQuery, UseQueryResult } from "@tanstack/react-query";
import getAPI from "../services/api";

const useTrails = ({
  page = 1,
  pageSize = 100,
  filters = {},
  sort = {},
  enabled = true,
  csv = false,
}: {
  page?: number;
  pageSize?: number;
  filters?: any;
  sort?: any;
  enabled?: boolean;
  csv?: boolean;
}): UseQueryResult<any> => {
  return useQuery(
    ["trails", page, pageSize, filters, sort, csv],
    async () => {
      const api = await getAPI();
      const { data } = await api.get("/trails", {
        params: {
          pagination: { pageSize, page },
          filters,
          sort,
          ...(csv ? { csv } : {}),
        },
      });
      return data;
    },
    { enabled }
  );
};

export default useTrails;
